/**
 * Route an open Students PA quote to the correct customer buy step.
 */
export function resolvePaCustomerResumeRoute(data) {
  const quoteId = String(data.quoteId);
  const step = data.stepCode || '';
  const startedApplication = step === 'PA_READY_FOR_PAYMENT'
    || !!(data.nationalId && data.kraPin);

  if (startedApplication) {
    return {
      name: 'CustomerPaSale',
      query: { quoteId },
    };
  }
  return {
    name: 'CustomerPaPlanSelect',
    query: { quoteId },
  };
}

/** Paid and policy number issued — view under My Policies, not Activity resume. */
export function isPaQuoteIssued(data) {
  const policyNo = String(data?.policyNumber || '').trim();
  const paid = data?.paymentStatus === true || data?.paymentStatus === 1;
  return paid && policyNo.length > 0;
}

/** Payment received, policy number not yet assigned — finalization polling. */
export function isPaQuoteAwaitingIssuance(data) {
  const policyNo = String(data?.policyNumber || '').trim();
  const paid = data?.paymentStatus === true || data?.paymentStatus === 1;
  return paid && !policyNo;
}
